import { User } from '@qogita/canary-types'

import { isQogitaUserEmail } from '#utils/isQogitaUserEmail'

export const getIsValidPortalUser = (user: User) =>
  isQogitaUserEmail(user.email) || user.isWarehouseUser || user.isSeller
